import React, { useEffect, useState } from "react";
import Continue from "../../components/Buttons/Button";
import { HiOutlineEye, HiOutlineEyeSlash } from "react-icons/hi2";
import Button from "../../components/Buttons/Button";
import Header from "../../components/Header";
import useWindowDimensions from "../../helpers/Hooks/useWindowDimensions";
import Version from "../../components/Version";
import ACCULogoSVG from "../../assets/ACCULogoSVG.svg";
import YodleeSVG from "../../assets/YodleeSVG.svg";
import { useNavigate } from "react-router-dom";
import { routes } from "../../helpers/Routes";
import { toast } from "react-hot-toast";

const Login = ({ setShowHeader }) => {
  const navigate = useNavigate();
  const { height, width } = useWindowDimensions();
  const [isDisabled, setIsDisabled] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const onContinueClick_Login = () => {
    if (username !== "" && password !== "") {
      navigate(routes.otp);
    }
  };

  // On tap the login to your account --> Populate the data in all fields
  const onPageTitleClick = (e) => {
    setUsername("peter.parker");
    setPassword("Peter@123");
  };

  useEffect(() => {
    if (username !== "" && password !== "") {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [username, password]);

  return (
    <>
      <Header />
      <main
        className="px-6 h-full flex flex-col"
        style={{ height: `${height - 76}px` }}
      >
        <main className="flex-grow">
          {/* Alabama */}
          <section className="mt-5 mb-6">
            <div className="flex items-center justify-center">
              <img className="mr-3 w-12 h-9" src={ACCULogoSVG} />
              <p className="text-base font-medium">
                Alabama Central
                <br /> Credit Union
              </p>
            </div>
          </section>
          <section className="flex items-center justify-center">
            <div className="mb-4 text-blackText text-xl font-bold cursor-pointer">
              Login to your account
            </div>
          </section>
          <section>
            {/* Username */}
            <div className="">
              <label className="labelTag">Username</label>
              <input
                type={"text"}
                placeholder={"Enter username"}
                className="inputTag"
                value={username}
                onClick={onPageTitleClick}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            {/* Password */}
            <div className="mt-3">
              <label className="labelTag">Password</label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder={"Enter password"}
                  className=" inputTag"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {showPassword ? (
                  <div
                    className="iconCon absolute top-[38%] right-3 text-grey  cursor-pointer"
                    onClick={() => setShowPassword(false)}
                  >
                    <HiOutlineEyeSlash className="openEyeIcon" />
                  </div>
                ) : (
                  <div
                    className="iconCon absolute top-[38%] right-3 text-grey cursor-pointer"
                    onClick={() => {
                      setShowPassword(true);
                      setTimeout(() => {
                        setShowPassword(false);
                      }, 2000);
                    }}
                  >
                    <HiOutlineEye className="closeEyeIcon" />
                  </div>
                )}
              </div>
            </div>
            {/* Forget Password */}
            <div className="my-3 flex items-center justify-end">
              <div className="text-primary text-sm font-semibold underline underline-offset-2">
                Forgot Password
              </div>
            </div>
          </section>
        </main>
        <main className="px-[5px] mb-3">
          <section className="flex items-center justify-center">
            <label
              htmlFor="terms_and_condition"
              className="text-blackText text-xs font-medium"
            >
              By continuing, you agree to{" "}
              <span className="text-primary underline">
                Yodlee's Terms of Use
              </span>{" "}
              for account linking. Your application provider's privacy notice
              applies to our handling of data.
            </label>
          </section>
        </main>
        <section>
          <Button
            name={"Continue"}
            isDisabled={isDisabled}
            onContinueClick_Login={onContinueClick_Login}
          />
        </section>
        {/* Yodlee */}
        <section className="mt-4 flex items-center justify-center">
          <div className="mr-[5px] text-xs font-medium text-grey">
            On behalf of NinjaFetch
            <br /> data access provided by
          </div>
          <img className="w-16 h-8" src={YodleeSVG} />
        </section>
        {/* <Version /> */}
      </main>
    </>
  );
};

export default Login;
